var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconModalClose = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "rgba(255,255,255,0.2)",
    transform: "translate(6 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(60,60,67,0.6)",
    d: "M2.314-.969A1.178 1.178 0 0 0 2.323.659a1.187 1.187 0 0 0 1.628.008l4.04-4.04L12.03.659A1.161 1.161 0 0 0 13.658.65a1.17 1.17 0 0 0 .009-1.628L9.636-5.009l4.031-4.04a1.17 1.17 0 0 0-.009-1.628 1.161 1.161 0 0 0-1.628-.009L7.991-6.654l-4.04-4.04a1.187 1.187 0 0 0-1.628.009 1.189 1.189 0 0 0-.009 1.637l4.04 4.04z",
    transform: "translate(12.008 25.014)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconModalClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-modal-close.a399dcef.svg";
export { ForwardRef as ReactComponent };